export default "__VITE_ASSET__BO6oukGQ__"